import {SHOW_MODAL, HIDE_MODAL, modalTypes} from './'
const {
  USER_PROFILE_EDIT,
  USER_EDIT,
  USER_ADD,
  SITE_ADD,
  INTEGRATION_ADD,
  INTEGRATION_UPLOAD,
  HELP_SHOW,
  NOTIFY_SHOW,
  REPORT_ADD,
  REPORT_DELETE_CONFIRM,
  SITE_DELETE_CONFIRM,
  CHANNEL_SELECTOR,
  PAYMENT_DETAILS,
  PAYMENT_CANCEL_SUBSCRIPTION_CONFIRM,
  PAYMENT_UPDATE_SUBSCRIPTION_PLAN_CONFIRM,
  INTEGRATIONS_NEW_SPREADSHEET,
  INTEGRATIONS_NEW_MANUAL_INPUT,
  INTEGRATIONS_NEW_CRITEO
} = modalTypes

export function openProfileEditForm() {
  return {
    type: SHOW_MODAL,
    modalType: USER_PROFILE_EDIT
  }
}

export function openIntegrationInfo(options) {
  return {
    type: SHOW_MODAL,
    modalType: INTEGRATION_ADD,
    modalProps: options
  }
}

export function openIntegrationUpload() {
  return {
    type: SHOW_MODAL,
    modalType: INTEGRATION_UPLOAD
  }
}

export function addUser() {
  return {
    type: SHOW_MODAL,
    modalType: USER_ADD
  }
}

export function editUser(options) {
  return {
    type: SHOW_MODAL,
    modalType: USER_EDIT,
    modalProps: options
  }
}

export function addSite() {
  return {
    type: SHOW_MODAL,
    modalType: SITE_ADD
  }
}

export function editSite(siteData) {
  return {
    type: SHOW_MODAL,
    modalType: SITE_ADD,
    modalProps: {
      initialValues: siteData,
      siteId: siteData.id,
      name: siteData.name,
      editForm: true
    }
  }
}

export function openHelp(siteData) {
  return {
    type: SHOW_MODAL,
    modalType: HELP_SHOW
  }
}

export function openNotify(siteData) {
  return {
    type: SHOW_MODAL,
    modalType: NOTIFY_SHOW
  }
}

export function openReportAddModal(report, crossSiteMode) {
  return {
    type: SHOW_MODAL,
    modalType: REPORT_ADD,
    modalProps: {report, crossSiteMode}
  }
}

export function reportDeleteConfirm(report) {
  return {
    type: SHOW_MODAL,
    modalType: REPORT_DELETE_CONFIRM,
    modalProps: {report}
  }
}

export function openChannelSelectorModal(options) {
  return {
    type: SHOW_MODAL,
    modalType: CHANNEL_SELECTOR,
    modalProps: options
  }
}

export function siteDeleteConfirm({siteId, name}) {
  return {
    type: SHOW_MODAL,
    modalType: SITE_DELETE_CONFIRM,
    modalProps: {siteId, name}
  }
}

export function openPaymentDetailsModal(options) {
  return {
    type: SHOW_MODAL,
    modalType: PAYMENT_DETAILS,
    modalProps: options
  }
}

export function cancelSubscriptionConfirm(options) {
  return {
    type: SHOW_MODAL,
    modalType: PAYMENT_CANCEL_SUBSCRIPTION_CONFIRM,
    modalProps: options
  }
}

export function updateSubscriptionConfirm(options) {
  return {
    type: SHOW_MODAL,
    modalType: PAYMENT_UPDATE_SUBSCRIPTION_PLAN_CONFIRM,
    modalProps: options
  }
}

export function closeModal() {
  return {
    type: HIDE_MODAL
  }
}

export function showAddNewSpreadSheet(options) {
  return {
    type: SHOW_MODAL,
    modalType: INTEGRATIONS_NEW_SPREADSHEET,
    modalProps: options
  }
}

export function showAddManualInput(options) {
  return {
    type: SHOW_MODAL,
    modalType: INTEGRATIONS_NEW_MANUAL_INPUT,
    modalProps: options
  }
}

export function showAddCriteo(options) {
  return {
    type: SHOW_MODAL,
    modalType: INTEGRATIONS_NEW_CRITEO,
    modalProps: options
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/ui/modal/actions.js